import { render } from "./HeadingWithIconGroup.vue?vue&type=template&id=9f2dfd10&scoped=true"
import script from "./HeadingWithIconGroup.vue?vue&type=script&lang=js"
export * from "./HeadingWithIconGroup.vue?vue&type=script&lang=js"

import "./HeadingWithIconGroup.vue?vue&type=style&index=0&id=9f2dfd10&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f2dfd10"]])

export default __exports__